import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatCNPJ, formatCPF } from "@/lib/api";
import SolimoesLogo from "@/components/SolimoesLogo";
import CredenciadoForm from "@/components/CredenciadoForm";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function CredenciarPublic() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    api.get(`/public/invitations/${token}`)
      .then(r => setInvite(r.data))
      .catch(e => setError(e.response?.data?.detail || "Convite inválido"));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="credenciar-error">
        <div className="card-soft p-10 max-w-md text-center">
          <AlertCircle className="h-12 w-12 text-rose-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-[#0E2A5C] mt-4">Convite indisponível</h1>
          <p className="text-slate-500 mt-2">{error}</p>
          <p className="text-xs text-slate-400 mt-4">Entre em contato com o gestor que enviou seu convite.</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="credenciar-success">
        <div className="card-soft p-10 max-w-md text-center">
          <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-[#0E2A5C] mt-4">Cadastro recebido!</h1>
          <p className="text-slate-600 mt-3">Obrigado por se credenciar à rede Solimões Card. Nosso gestor irá validar seus dados em até 24h e o contrato chegará no seu e-mail.</p>
        </div>
      </div>
    );
  }

  if (!invite) return <div className="min-h-screen flex items-center justify-center" data-testid="credenciar-loading"><div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-[#2A8FE0] animate-spin" /></div>;

  const initial = {
    name: invite.name,
    person_type: invite.person_type,
    document: invite.document,
    contacts: { email: invite.email, phone: invite.phone, whatsapp: invite.phone },
    ...(invite.prefilled || {}),
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] py-10 px-4" data-testid="credenciar-public-page">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <SolimoesLogo className="h-12 w-auto" />
          <span className="text-xs font-bold uppercase tracking-widest text-[#2A8FE0]">Credenciamento</span>
        </div>
        <div className="rounded-3xl p-8 mb-6 text-white" style={{background: "linear-gradient(135deg, #0E2A5C 0%, #2A8FE0 100%)"}}>
          <div className="text-xs uppercase tracking-widest opacity-85">Olá, {invite.name}</div>
          <h1 className="font-display text-3xl lg:text-4xl font-black mt-2">Bem-vindo(a) à rede Solimões Card</h1>
          <p className="mt-3 opacity-90 max-w-2xl">Complete seu cadastro para começarmos o processo de credenciamento. Após o envio, nosso gestor validará seus dados e enviará o contrato para sua assinatura.</p>
        </div>

        <CredenciadoForm
          initial={initial}
          isPublic
          submitToken={token}
          onSaved={() => setSubmitted(true)}
        />
      </div>
    </div>
  );
}
